export default "__VITE_PUBLIC_ASSET__4dec6c98__"